import firebase from 'firebase'
import { Driver } from '../../types/driver'

export type FirebaseUser = firebase.User
export type FirebaseError = firebase.FirebaseError

/**
 * The auth state which, when combined with the auth methods, make up the return object of the `useAuth` hook.
 */
export interface AuthState {
	isAuthenticated: boolean
	currentFirebaseUser?: FirebaseUser
	currentDriver?: Driver
	isLoading: boolean
	error?: FirebaseError
}

/**
 * The initial auth state.
 */
export const initialAuthState: AuthState = {
	isAuthenticated: false,
	isLoading: false,
}
